"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoFocus = void 0;
const react_1 = require("react");
function useAutoFocus() {
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    }, []);
    return inputRef;
}
exports.useAutoFocus = useAutoFocus;
//# sourceMappingURL=useAutoFocus.js.map